export const normalizeFilters = filters => {
  const normalizedFilters = {
    state: (filters.state || [])
      .map(filter => filter.value)
      .filter(filter => filter !== 'all'),
    node_type: (filters.node_type || [])
      .map(filter => filter.value)
      .filter(filter => filter !== 'all'),
    targets: (filters.targets || [])
      .map(filter => filter.value)
      .filter(filter => filter !== 'all'),
    languages: (filters.languages || [])
      .map(filter => filter.value)
      .filter(filter => filter !== 'all'),
  };

  if (normalizedFilters.state.length > 1) normalizedFilters.state = [];
  if (
    normalizedFilters.state.length === 1 &&
    normalizedFilters.state[0] === 'active'
  )
    normalizedFilters.state = true;
  if (
    normalizedFilters.state.length === 1 &&
    normalizedFilters.state[0] === 'inactive'
  )
    normalizedFilters.state = false;

  Object.keys(normalizedFilters).forEach(key => {
    if (normalizedFilters[key].length === 0) delete normalizedFilters[key];
  });

  return normalizedFilters;
};

export const normalizeResponse = response => {
  const DEFAULT_ORDER = [
    'stories',
    'sub_stories',
    'nodes',
    'user_responses',
    'bot_responses',
    'generic_responses',
  ];

  let results = [];
  DEFAULT_ORDER.forEach(key => {
    results = results.concat(
      response[key].map(result => ({ ...result, type: key }))
    );
  });

  return results;
};
